<template>
    <div>
        <el-dialog
            :visible="showDialog"
            width="100%"
            :fullscreen="true"
            :show-close="false"
            custom-class="custom-dialog"
        >
            <div class="row">
                <div class="col-12">
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <div>
                            <el-select v-model="format" style="width: 100px;"
                                @change="changeFormat"
                            >
                                <el-option value="a4" label="A4"></el-option>
                                <el-option v-if="ShowTicket80" value="ticket" label="80MM"></el-option>
                                <el-option v-if="ShowTicket58" value="ticket_58" label="58MM"></el-option>
                                <el-option v-if="ShowTicket50" value="ticket_50" label="50MM"></el-option>
                                <el-option value="a5" label="A5"></el-option>
                            </el-select>
                        </div>
                        <div>
                            <h3 class="text-danger font-bold">VISTA PREVIA</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-loading="loading">
                <div class="col-12" style="min-height: 80vh;">
                    <iframe
                        :src="url_pdf"
                        type="application/pdf"
                        width="100%"
                        height="100%"
                    ></iframe>
                </div>
            </div>

            <div class="row">
                <div class="col-12 mt-3 text-left">
                    <el-button type="primary" native-type="button" @click="closeDialog">Cerrar</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from "vuex/dist/vuex.mjs"

    export default {
        props: ['showDialog', 'preview'],
        data() {
            return {
                format: "a4",
                url_pdf: null,
                urls: [],
                loading: false
            }
        },
        watch: {
            async showDialog() {
                if (this.showDialog) {
                    await this.loadPdf()
                }
            },
        },
        computed: {
            ...mapState(["config"]),
            ShowTicket58: function () {
                if (this.config === undefined) return false;
                if (this.config == null) return false;
                if (this.config.show_ticket_58 === undefined) return false;
                if (this.config.show_ticket_58 == null) return false;
                if (
                this.config.show_ticket_58 !== undefined &&
                this.config.show_ticket_58 !== null
                ) {
                    return this.config.show_ticket_58;
                }
                return false;
            },
            ShowTicket80: function () {
                if (this.config === undefined) return false;
                if (this.config == null) return false;
                if (this.config.show_ticket_80 === undefined) return false;
                if (this.config.show_ticket_80 == null) return false;
                if (
                this.config.show_ticket_80 !== undefined &&
                this.config.show_ticket_80 !== null
                ) {
                    return this.config.show_ticket_80;
                }
                return false;
            },
            ShowTicket50: function () {
                if (this.config === undefined) return false;
                if (this.config == null) return false;
                if (this.config.show_ticket_50 === undefined) return false;
                if (this.config.show_ticket_50 == null) return false;
                if (
                this.config.show_ticket_50 !== undefined &&
                this.config.show_ticket_50 !== null
                ) {
                    return this.config.show_ticket_50;
                }
                return false;
            },
        },
        methods: {
            closeDialog() {
                this.$emit("update:showDialog", false)
                this.url_pdf = null
                this.urls = []
            },

            async loadPdf() {
                this.url_pdf = null
                let exists = this.urls.find((item) => item.format === this.format)
                if (exists) {
                    this.url_pdf = exists.URL
                } else {
                    this.loading = true
                    this.url_pdf = await this.preview(this.format)
                    this.urls = [...this.urls, { format: this.format, URL: this.url_pdf }]
                    this.loading = false
                }
            },

            async changeFormat() {
                await this.loadPdf()
            }
        }
    }
</script>
<style>
    .custom-dialog > .el-dialog__header {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/tenant/sale_notes/partials/preview.vue